import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Gift, CheckCircle } from 'lucide-react';
import ebook from '../../components/assets/ebook.jpg';

const FEMFreeEbook = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-blue-50 to-green-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="relative"
          >
            <div className="relative aspect-[3/4] rounded-2xl overflow-hidden shadow-2xl">
              <img
                src={ebook}
                alt="Book Cover"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/30 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
                <div className="inline-flex items-center px-4 py-2 bg-green-500 rounded-full text-sm font-medium mb-4">
                  <Gift className="h-4 w-4 mr-2" />
                  FREE with Registration
                </div>
                <h3 className="text-2xl font-bold mb-2">
                  A-Z of Mini Exporting
                </h3>
                <p className="text-gray-200">
                  How to Build a Multi-Million Dollar Empire Exporting Foodstuffs
                </p>
              </div>
            </div>
            <div className="absolute -top-6 -right-6 bg-red-600 text-white px-6 py-3 rounded-full transform rotate-12 shadow-lg">
              <div className="text-sm font-medium line-through">₦25,000</div>
              <div className="text-xl font-bold">FREE</div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <div className="space-y-8">
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-4">
                  Get Your Free eBook
                </h2>
                <p className="text-xl text-gray-600">
                  Register for the Foodstuff Export Masterclass and receive our comprehensive guide worth ₦25,000 absolutely FREE!
                </p>
              </div>

              <div className="space-y-4">
                <h3 className="text-xl font-semibold text-gray-900 flex items-center">
                  <BookOpen className="h-6 w-6 text-green-600 mr-2" />
                  What You'll Learn
                </h3>
                <div className="grid gap-3">
                  {[
                    'Step-by-step guide to starting your export business',
                    'Identifying profitable foodstuff products',
                    'Market research and buyer identification',
                    'Documentation and compliance requirements',
                    'Pricing strategies and profit maximization',
                    'Risk management and quality control'
                  ].map((item, index) => (
                    <div key={index} className="flex items-start">
                      <CheckCircle className="h-5 w-5 text-green-600 mr-3 flex-shrink-0 mt-0.5" />
                      <span className="text-gray-700">{item}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="bg-white rounded-xl p-6 shadow-lg border border-gray-100">
                <div className="flex items-center text-green-600 mb-2">
                  <Gift className="h-5 w-5 mr-2" />
                  <span className="font-medium">Exclusive Bonus</span>
                </div>
                <p className="text-gray-700">
                  Get instant access to our premium export templates and checklists worth an additional ₦25,000 when you register for the masterclass!
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default FEMFreeEbook;